export default __webpack_public_path__ + "static/media/discover.2f054b3f.png";